import React from 'react';
import Localize from 'react-intl-universal';
import { useLocation, useNavigate } from 'react-router-dom';

// import BuildIcon from '@mui/icons-material/Build';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import HomeIcon from '@mui/icons-material/Home';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { isDisableNavigationOn, isFraunhofer } from '@common/Util';

const StyledContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  marginTop: '-2.92rem',
  paddingTop: '2.92rem',
  paddingBottom: '2.5rem',
  marginBottom: '-2.5rem',
  background: theme.palette.background.primary,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center'
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.contrastText
}));

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMaintenance = searchParams.get('maintenance') === 'true';

  const handleGoHome = () => {
    navigate('/', {
      replace: true
    });
  };

  return (
    <StyledContainer>
      <Box sx={{ mb: 2 }}>
        {isMaintenance ? (
          <EventBusyIcon sx={{ fontSize: 110, color: 'primary.main' }} />
        ) : (
          <SentimentVeryDissatisfiedIcon sx={{ fontSize: 90, color: 'primary.main' }} />
        )}
      </Box>
      <StyledTypography sx={{ fontSize: '2rem', fontWeight: 500 }}>
        {isMaintenance ? Localize.get('NotFound.maintenance') : Localize.get('NotFound.wrongURL')}
      </StyledTypography>
      <StyledTypography mb={4} sx={{ fontSize: '1.2rem' }}>
        {isMaintenance ? Localize.get('NotFound.tryLater') : Localize.get('NotFound.tryAgain')}
      </StyledTypography>
      {!isDisableNavigationOn(location) && !isFraunhofer() && (
        <Button
          variant='contained'
          sx={(theme) => ({ color: theme.palette.common.white })}
          startIcon={<HomeIcon />}
          onClick={handleGoHome}
        >
          {Localize.get('NotFound.goToHomePage')}
        </Button>
      )}
    </StyledContainer>
  );
};

export default NotFound;
